import request from '@/utils/request'

export function login(username, userpwd) {
  return request({
    url: '/Login/agency_login',
    method: 'post',
    data: {
      username,
      userpwd
    }
  })
}

export function getInfo() {
  return request({
    url: '/Agency/get_login_menu_config',
    method: 'get',
  })
}
// 更新头像
export function update_avatar(data) {
  return request({
    url: '/Agency/update_avatar',
    method: 'post',
    data: data
  })
}
// 更新密码
export function update_password(data) {
  return request({
    url: '/Agency/update_password',
    method: 'post',
    data: data
  })
}
// 更新用户信息
export function update_data(data) {
  return request({
    url: '/Agency/update_data',
    method: 'post',
    data: data
  })
}

export function get_agency_member(params) {
  return request({
    url: '/Agency/get_agency_member',
    method: 'get',
    params: params
  })
}


export function logout() {
  return request({
    url: '/Agency/agency_logout',
    method: 'post'
  })
}



export function fetchList(params) {
  return request({
    url: '/Agency/get_agency_member_list',
    method: 'get',
    params: params
  })
}

export function createAdmin(data) {
  return request({
    url: '/Agency/save_agency_member',
    method: 'post',
    data: data
  })
}

export function updateAdmin(data) {
  return request({
    url: '/Agency/save_agency_member',
    method: 'post',
    data: data
  })
}

export function updateStatus(params) {
  return request({
    url: '/Agency/set_manager_status',
    method: 'post',
    params: params
  })
}

export function get_feedback_list(params) {
  return request({
    url: '/Agency/get_feedback_list',
    method: 'get',
    params: params
  })
}


export function deleteAdmin(data) {
  return request({
    url: '/Agency/del_agency_member',
    method: 'post',
    data: data
  })
}

export function getRoleByAdmin(id) {
  return request({
    url: '/admin/role/' + id,
    method: 'get'
  })
}

export function allocRole(data) {
  return request({
    url: '/admin/role/update',
    method: 'post',
    data: data
  })
}

// 行政区划查询：keywords=空字符串返回省级行政区；keywords=省/市名称返回其下级行政区；subdistrict=0 表示返回自身，1 返回下一级
export function get_district(params) {
  return request({
    url: '/Login/get_district',
    method: 'get',
    params: params
  })
}





// WEBPACK FOOTER //
// ./src/api/login.js